var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "theme-container",
    class: _vm.pageClasses,
    on: {
      "touchstart": _vm.onTouchStart,
      "touchend": _vm.onTouchEnd
    }
  }, [_vm.shouldShowNavbar ? _c('Navbar', {
    on: {
      "toggle-sidebar": _vm.toggleSidebar
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sidebar-mask",
    on: {
      "click": function ($event) {
        return _vm.toggleSidebar(false);
      }
    }
  }), _vm._v(" "), _vm.$themeConfig.sidebarHoverTriggerOpen !== false ? _c('div', {
    staticClass: "sidebar-hover-trigger"
  }) : _vm._e(), _vm._v(" "), _c('Sidebar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showSidebar,
      expression: "showSidebar"
    }],
    attrs: {
      "items": _vm.sidebarItems
    },
    on: {
      "toggle-sidebar": _vm.toggleSidebar
    },
    scopedSlots: _vm._u([_vm.sidebarSlotTop ? {
      key: "top",
      fn: function () {
        return [_c('div', {
          staticClass: "sidebar-slot sidebar-slot-top",
          domProps: {
            "innerHTML": _vm._s(_vm.sidebarSlotTop)
          }
        })];
      },
      proxy: true
    } : null, _vm.sidebarSlotBottom ? {
      key: "bottom",
      fn: function () {
        return [_c('div', {
          staticClass: "sidebar-slot sidebar-slot-bottom",
          domProps: {
            "innerHTML": _vm._s(_vm.sidebarSlotBottom)
          }
        })];
      },
      proxy: true
    } : null], null, true)
  }), _vm._v(" "), _vm.$page.frontmatter.home ? _c('Home') : _vm.$page.frontmatter.categoriesPage ? _c('CategoriesPage') : _vm.$page.frontmatter.tagsPage ? _c('TagsPage') : _vm.$page.frontmatter.archivesPage ? _c('ArchivesPage') : _c('Page', {
    attrs: {
      "sidebar-items": _vm.sidebarItems
    },
    scopedSlots: _vm._u([_vm.pageSlotTop ? {
      key: "top",
      fn: function () {
        return [_c('div', {
          staticClass: "page-slot page-slot-top",
          domProps: {
            "innerHTML": _vm._s(_vm.pageSlotTop)
          }
        })];
      },
      proxy: true
    } : null, _vm.pageSlotBottom ? {
      key: "bottom",
      fn: function () {
        return [_c('div', {
          staticClass: "page-slot page-slot-bottom",
          domProps: {
            "innerHTML": _vm._s(_vm.pageSlotBottom)
          }
        })];
      },
      proxy: true
    } : null], null, true)
  }), _vm._v(" "), _c('Footer'), _vm._v(" "), _c('Buttons', {
    ref: "buttons",
    on: {
      "toggle-theme-mode": _vm.toggleThemeMode
    }
  }), _vm._v(" "), _vm.$themeConfig.bodyBgImg ? _c('BodyBgImg') : _vm._e(), _vm._v(" "), _vm.windowLB ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showWindowLB,
      expression: "showWindowLB"
    }],
    staticClass: "custom-html-window custom-html-window-lb"
  }, [_c('div', {
    staticClass: "custom-wrapper"
  }, [_c('span', {
    staticClass: "close-but",
    on: {
      "click": function ($event) {
        _vm.showWindowLB = false;
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.windowLB)
    }
  })])]) : _vm._e(), _vm._v(" "), _vm.windowRB ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showWindowRB,
      expression: "showWindowRB"
    }],
    staticClass: "custom-html-window custom-html-window-rb"
  }, [_c('div', {
    staticClass: "custom-wrapper"
  }, [_c('span', {
    staticClass: "close-but",
    on: {
      "click": function ($event) {
        _vm.showWindowRB = false;
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.windowRB)
    }
  })])]) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };